import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import SolarSunriseLinear from "../icons/SolarSunriseLinear";
import SolarInboxLineLinear from "../icons/SolarInboxLineLinear";
import SolarHammerLinear from "../icons/SolarHammerLinear";
import SideBarTasks from "./SideBarTasks";
import { useSettings } from "context/SettingsContext";
import { useAuth } from "context/AuthContext";

const SideBar4Team = ({setMobSideBarShow}) => {
    const { t } = useTranslation();
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const location = useLocation();
    
    const handleClickOnSideBar = (e) => {
        if (e?.target?.classList?.contains('hide-sidebar'))
            setMobSideBarShow(false);
    }

    const teamName = localSettings?.DIRS?.Team?.find(team=>team.ID == auth?.user?.access?.team)?.teamName||'Error Team';

    return (
        <ul className="pc-navbar d-block"
            onClick={handleClickOnSideBar}>
                <li className="pc-item pc-caption">
                    <label>{teamName}</label>
                </li>

                <SideBarTasks variant="team" />

                <li className={`pc-item  ${location.pathname == '/4team/objects' ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/4team/objects">
                        <span className="pc-micon pc-micon--objects">
                            <SolarSunriseLinear/> 
                        </span>
                        <span className="pc-mtext">{t('SideBar4Team.titleObjects')}</span>
                    </Link>
                </li>
                <li className={`pc-item  ${location.pathname == '/4team/warehouse' ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/4team/warehouse">
                        <span className="pc-micon pc-micon--warehouses">
                            <SolarInboxLineLinear/> 
                        </span>
                        <span className="pc-mtext">{t('SideBar4Team.titleWarehouse')}</span>
                    </Link>
                </li>
                <li className={`pc-item  ${location.pathname.startsWith('/tools') ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/tools/my">
                        <span className="pc-micon pc-micon--tools">
                            <SolarHammerLinear/>
                        </span>
                        <span className="pc-mtext">{t('SideBar4Team.titleTools')}</span>
                    </Link>
                </li>                
        </ul>
    )
 
}

export default SideBar4Team;